$(document).ready(function () {

    /***
     * EVENT HANDLERS
     */

    // select2
    function refreshSelect2() {

        $('.profile-drones__drone-pairs .drones_name').each(function () {
            $(this).select2({
                width: '100%',
                placeholder: $(this).attr('placeholder'),
                allowClear: true
            });
        });

        $('#sensors').select2({
            width: '100%',
            placeholder: $('#sensors').attr('placeholder')
        });

        $('#cameras').select2({
            width: '100%',
            placeholder: $('#cameras').attr('placeholder')
        });

        $('#softwares').select2({
            width: '100%',
            placeholder: $('#softwares').attr('placeholder')
        });

        $('#aircraftSelect').select2({
            width: '100%',
            placeholder: $('#aircraftSelect').attr('placeholder'),
        })

        $('#sensorSelect').select2({
            width: '100%',
            placeholder: $('#sensorSelect').attr('placeholder'),
        })
    }
    $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
        refreshSelect2();
    });


    // Handle credential adding
    // Adds are done by looking at a hidden 'template' credential
    if ($('.credentials__credentials-pair').length < 1) {
        addCredentials();
    }
    $('#addMoreCredentials').click(function () {
        addCredentials();
    });
    function addCredentials() {
        var original = $('.credentials__credentials-template');
        var el = original.clone();
        el.removeClass('credentials__credentials-template')
        el.removeClass('d-none');
        original.before(el);
    }


    // Handle 'drone' adding with hidden template
    if ($('.profile-drones__drone-pairs').children().length < 1) {
        addDrone();
    }
    $('.profile-drones__add-more-link').click(function () {
        addDrone();
    });
    function addDrone() {
        var original = $('.profile-drones__drone-pair-template');
        var currentCount = $('.drone-pair').length - 1;
        var el = original.clone().html();
        $('.profile-drones__drone-pairs').append(el);
        el = $('.profile-drones__drone-pairs .drone-pair:last');
        el.addClass('drone-pair--' + currentCount);
        var select = el.find('select');
        if (select.attr('id') == 'drones_name_0') {
            select.attr('id', 'drones_name_f' + currentCount);
        }
        refreshSelect2();
    }


    // Handle 'other equipment adding with hidden template
    if ($('.profile-other__items').children().length < 1) {
        addOtherEquipment();
    }
    $('.profile-other__add-more-link').click(function () {
        addOtherEquipment();
    });
    function addOtherEquipment() {
        var original = $('.profile-other__template');
        var currentCount = $('.profile-other__items > .row').length;
        var el = original.clone();
        el = el.html()
        $('.profile-other__items').append(el);
        $('.profile-other__items > .row:last').addClass('profile-other__items--' + currentCount);
    }


    var pdfAcceptedFiles = 'application/pdf,.pdf';
    var pdfMaxFilesize = 4; // MB
    var imageAcceptedFiles = 'image/*';
    var imageMaxFilesize = 3; // MB
    // Uploads: Avatar
    $('#uploadAvatar').dropzone({
        acceptedFiles: imageAcceptedFiles,
        maxFilesize: imageMaxFilesize,
        previewTemplate: '<span></span>',
        paramName: 'avatar',
        url: '/avatar',
        sending: function (_, __, formData) {
            formData.append('_token', token);
        },
        success: function () {
            $('#uploadAvatar').css('backgroundImage', `url("/avatar?v=${new Date().getTime()}")`);
        }, error: function (_, message) {
            errorToast(message);
        }
    });

    // Uploads: Proof of Insurance
    $('#uploadProofOfInsurance').dropzone({
        acceptedFiles: pdfAcceptedFiles,
        maxFilesize: pdfMaxFilesize,
        url: `/proofOfInsurance/${$('#uploadProofOfInsurance').data('id')}`,
        sending: function (_, __, formData) {
            formData.append('_token', token);
        },
        success: function () {
            $('#uploadProofOfInsurance').find('.dz-preview').fadeOut(2000);
            $('.proof-of-insurance__download-link')
                .removeClass('proof-of-insurance__download-link--empty')
                .addClass('proof-of-insurance__download-link--exists');
            $('.proof-of-insurance__dropzone')
                .removeClass('proof-of-insurance__dropzone--empty')
                .addClass('proof-of-insurance__dropzone--exists');
        }, error: function (_, message) {
            errorToast(message);
            $('#uploadProofOfInsurance').find('.dz-preview').fadeOut(2000);
        }
    }).addClass('dropzone');

    // Uploads: Client Consent Form
    $('#uploadClientConsentForm').dropzone({
        acceptedFiles: pdfAcceptedFiles,
        maxFilesize: pdfMaxFilesize,
        url: `/clientConsentForm/${$('#uploadClientConsentForm').data('id')}`,
        sending: function (_, __, formData) {
            formData.append('_token', token);
        },
        success: function () {
            $('#uploadClientConsentForm').find('.dz-preview').fadeOut(2000);
            $('.client-consent__download-link')
                .removeClass('client-consent__download-link--empty')
                .addClass('client-consent__download-link--exists');
            $('.client-consent__dropzone')
                .removeClass('client-consent__dropzone--empty')
                .addClass('client-consent__dropzone--exists');
        }, error: function (_, message) {
            errorToast(message);
            $('#uploadClientConsentForm').find('.dz-preview').fadeOut(2000);
        }
    }).addClass('dropzone');

    $('#consent').on( 'click', (e)=>{
        if($('#consent').prop('checked')){
            $('button.signin').removeAttr('disabled');
            $('#consent').off('click');
        }  
    });

    /*
     * COLLECTION OF VARIOUS DOM MANIPULATIONS
     */
    // ADD INPUT FIELDS FOR ADDITIONAL DRONES / FAA REGISTRATION

    // ADD INPUT FIELD FOR ADDITIONAL 'OTHER' EQUIPMENT
    $('#add-other-equip').click(function () {
        $('.other-equip').append(`<input type="text" class="mb-2 form-control" name="other_equip[]" value="" placeholder="Please include any other equipment not included above"></input>`)
    });

    // DISABLE SUBMIT BUTTON UNTIL CHECKBOX IS CHECKED
    $('#verify_info').click(function () {
        if (!$(this).is(':checked')) {
            $('#verify__submit').attr('disabled', 'disabled');
        } else {
            $('#verify__submit').removeAttr('disabled');
        }
    });

    /**
     * HANDLE TABS AND HASH NAVIGATION
     * This should remain near the bottom of this closure, at least after all other
     * event handlers have been created
     */
    var tabs = [
        '#pilot_info',
        '#equip',
        '#verify',
        '#mission_details',
    ];

    openTabFromHash(tabs, window.location.hash);
});
